import React from "react";

import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineLocationOff, MdOutlineAddLocation } from "react-icons/md";

import { DefaultTooltip } from "../Generic/Tooltip";
import useStyles from "./styles";

interface Props {
  uuid?: string;
  loading?: boolean;
  add: () => void;
  remove: () => void;
}

const RowActionRoutePlanner = (props: Props) => {
  const { uuid, add, remove, loading } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (loading) {
    return <CircularProgress size={20} />;
  }

  return (
    <DefaultTooltip
      title={uuid ? translate("removeFromRoutePlanner") : translate("addToRoutePlanner")}
    >
      <div className={classes.cursorPointer}>
        {uuid ? (
          <MdOutlineLocationOff size={20} data-cy="removeRoutePlanner" onClick={remove} />
        ) : (
          <MdOutlineAddLocation size={20} role="button" data-cy="addRoutePlanner" onClick={add} />
        )}
      </div>
    </DefaultTooltip>
  );
};

RowActionRoutePlanner.AddIcon = MdOutlineAddLocation;
RowActionRoutePlanner.RemoveIcon = MdOutlineLocationOff;
export default RowActionRoutePlanner;
